import { TrustSignals } from '@dbt-labs/metadata-shared';

import { AccessLevel } from '@/__generated__/graphql';
import { ResourceAppliedNode } from '@/hooks/discovery/resource';

/**
 * Can be used to safely retrieve the access level from a ResourceAppliedNode
 */
export const getAccess = (
  currentNode: ResourceAppliedNode | undefined,
): AccessLevel | undefined =>
  currentNode?.__typename === 'ModelAppliedStateNode'
    ? (currentNode?.access as AccessLevel)
    : undefined;

/**
 * Can be used to safely retrieve trust signals info from a ResourceAppliedNode
 */
export const getTrustSignals = (
  currentNode: ResourceAppliedNode | undefined,
): TrustSignals => {
  if (!currentNode) {
    return { healthIssues: [] };
  }
  switch (currentNode.__typename) {
    case 'ModelAppliedStateNode':
      return { healthIssues: currentNode.modelHealthIssues };
    case 'SourceAppliedStateNode':
      return {
        healthIssues: currentNode.sourceHealthIssues,
        additionalMetadata: {
          freshnessChecked: currentNode.freshness?.freshnessChecked,
        },
      };
    case 'ExposureAppliedStateNode':
      return { healthIssues: currentNode.exposureHealthIssues };
    default:
      return { healthIssues: [] };
  }
};
